import React, { Suspense, lazy } from 'react';
import { Routes, Navigate, Route, useLocation } from 'react-router-dom';

import SiteLayout from './layouts/SiteLayout';
import MainLayout from './layouts/MainLayout';
// import HomeLayout from './layouts/HomeLayout';

import GuestGuard from './guards/GuestGuard';
import UserGuard from './guards/UserGuard';

import LoadingScreen from './components/LoadingScreen';
import Login from './views/auth/Login';
import SSOCallback from './views/auth/SSOCallback';
import Register from './views/auth/Register';
import Dashboard from './views/user/Dashboard/Dashboard';
import AllAccount from './views/user/All Account/AllAccount';
import LandingPage from './views/auth/LandingPage';
import Page404 from './views/errors/Page404';
import VerifyAccountPassword from './views/auth/ForgetPass/VerifyAccountPassword';
import ForgetPass from './views/auth/ForgetPass';
import EditProfile from './views/user/EditProfile/EditProfile';
import ChangePassword from './views/user/ChangePasssword/ChangePasssword';
import Help from './views/user/Help/help';
import LoginWithOtp from './views/auth/Login/LoginWithOtp';
import AddAdmin from './views/user/Add-Admin';
import AddStaf from './views/user/Staf/AddStaf';
import StafList from './views/user/Staf/StafList';
import AccountPreview from './views/user/All Account/AccountPreview';
import EventList from './views/user/Event/EventList';
import EditEvent from './views/user/Event/EditEvent';
import EventDetails from './views/user/Event/EventDetails';
import Setting from './views/user/Setting/Setting';
import Transaction from './views/user/Transaction/Transaction';
import Faq from './views/user/Faq';
import CMS from './views/user/CMS';
import Terms from './views/auth/CMSPages/Terms';
import Privacy from './views/auth/CMSPages/Privacy';
import EmailMarketingPage from './views/user/Setting/Setting';
import AllCreators from './views/user/All-Creators/AllCreators';
import CreatorOnboarding from './views/user/All-Creators/OnboardingCreators';
import Moderation from './views/user/Moderation/Moderation';
import Payouts from './views/user/Payouts/Payouts';
import Conversations from './views/user/Conversations/Conversations';
import Reports from './views/user/Reports/Reports';
import Analytics from './views/user/Analytics/Analytics';
// import Home from './views/Home';


export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>

    <Routes>
      {routes.map((route, i) => {
        const location = useLocation();
        // const Guard = route.guard || Fragment;
        // const Layout = route.layout || Fragment;
        // const Component = route.component;
        let UNAUTH_ROUTE = ["/", "/login", "/register", "/forget-pass", "/login-with-otp", "/otp-verification", '/terms', '/privacy']
        let AUTH_ROUTE = ["/user/dashboard", "/user/all-accounts", "/user/edit-profile", "/user/add-admin",
          "/user/change-password", "/user/help", "/user", "/user/creators", "/user/creator-onboarding",
          "/user/moderation", "/user/payouts", "/user/conversations", "/user/reports",
          "/user/setting", "/user/transaction", "/user/faq-management", "/user/cms-management",
          "/user/analytics",
        ]
        if (location.pathname === "/sso-callback") {
          return (
            <Route
              key={i}
              path="/sso-callback"
              element={<SSOCallback />}
            />
          );
        }
        return (
          UNAUTH_ROUTE.includes(location.pathname)
            ?
            <Route
              key={i}
              path={location.pathname}
              // exact={route.exact}
              exact={true}
              element={
                <GuestGuard>
                  <SiteLayout>
                    {(
                      // location.pathname === "/") ? <LandingPage />
                      location.pathname === "/") ? <Navigate to="/login" />
                      : (location.pathname === "/login") ? <Login />
                        : location.pathname === "/register" ? <Register />
                          : location.pathname === "/forget-pass" ? <ForgetPass />
                            : location.pathname === "/login-with-otp" ? <LoginWithOtp />
                              : location.pathname === "/otp-verification" ? <VerifyAccountPassword />
                                : location.pathname === "/terms" ? <Terms />
                                  : location.pathname === "/privacy" ? <Privacy />
                                    : ""
                    }
                  </SiteLayout>
                </GuestGuard>
              }
            />
            //   : (location.pathname.includes("/user/dashboard")
            //   || location.pathname.includes("/user")
            // )
            : AUTH_ROUTE.includes(location.pathname) ?
              <Route
                key={i}
                path={location.pathname}
                // exact={route.exact}
                exact={true}
                element={
                  <UserGuard>
                    <MainLayout>
                      {location.pathname.includes("/user/dashboard") ? <Dashboard />
                        : location.pathname.includes("/user/all-accounts") ? <AllAccount />
                          : location.pathname.includes("/user/reports") ? <Reports />
                          : location.pathname.includes("/user/analytics") ? <Analytics />
                            : location.pathname.includes("/user/creator-onboarding") ? <CreatorOnboarding />
                              : location.pathname.includes("/user/creators") ? <AllCreators />
                                : location.pathname.includes("/user/moderation") ? <Moderation />
                                  : location.pathname.includes("/user/payouts") ? <Payouts />
                                    : location.pathname.includes("/user/conversations") ? <Conversations />
                                      : location.pathname.includes("/user/accountPreview") ? <AccountPreview />
                                        : location.pathname.includes("/user/edit-profile") ? <EditProfile />
                                          : location.pathname.includes("/user/add-admin") ? <AddAdmin />
                                            : location.pathname.includes("/user/add-staf") ? <AddStaf />
                                              : location.pathname.includes("/user/all-staf") ? <StafList />
                                                : location.pathname.includes("/user/change-password") ? <ChangePassword />
                                                  : location.pathname.includes("/user/help") ? <Help />
                                                    : location.pathname.includes("/user/event-list") ? <EventList />
                                                      : location.pathname.includes("/user/edit-events") ? <EditEvent />
                                                        : location.pathname.includes("/user/event-details") ? <EventDetails />
                                                          : location.pathname.includes("/user/setting") ? <EmailMarketingPage />
                                                            : location.pathname.includes("/user/transaction") ? <Transaction />
                                                              : location.pathname.includes("/user/faq-management") ? <Faq />
                                                                : location.pathname.includes("/user/cms-management") ? <CMS />

                                                                  : location.pathname.includes("/user") ? <Navigate to="/user/dashboard" />

                                                                    : <Navigate to="/404" />
                      }
                    </MainLayout>
                  </UserGuard>
                }
              />
              :
              <Route
                key={i}
                path={location.pathname}
                // exact={route.exact}
                exact={true}
                element={
                  <>
                    <>
                      <Navigate to="/404" />
                      <Page404 />
                    </>
                  </>
                }
              />
        );
      })}
    </Routes>
  </Suspense>
);

const routes = [
  // anonymous routes
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('./views/errors/Page404'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/',
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/login',
    // component: lazy(() => import('./views/auth/Login'))
  },
  {
    exact: true,
    path: '/sso-callback',
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/register',
    // component: lazy(() => import('./views/auth/Register'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/otp-verification',
    // component: lazy(() => import('./views/auth/ForgetPass/VerifyAccountPassword'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/forget-pass',
    // component: lazy(() => import('./views/auth/ForgetPass'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/terms',
    // component: lazy(() => import('./views/auth/ForgetPass/VerifyAccountPassword'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/privacy',
    // component: lazy(() => import('./views/auth/ForgetPass/VerifyAccountPassword'))
  },
  {
    exact: true,
    path: '/user',
    guard: UserGuard,
    layout: MainLayout,
    component: () => <Navigate to="/user/dashboard" />
  },
  {
    exact: true,
    path: '/user/dashboard',
    guard: UserGuard,
    layout: MainLayout,
    // component: React.lazy(() => import('./views'))
  },
  {
    exact: true,
    path: '/user/all-accounts',
    guard: UserGuard,
    layout: MainLayout,
    // component: React.lazy(() => import('./views'))
  },

];

export default routes;
